import React from "react";
import { Button } from "arv-reactcomponents";

import { Header, Anchor, Analytics } from "arv-extends";
import { ROUTE_PATHS, TOPBAR } from "npmlinks-constants";
const {
  EventFactory: { GTMEvent }
} = Analytics;
const { wrapper, getFinalComponent } = Header.MobileHeader.MobileActionButton;

class ProjectComponent extends wrapper {
  constructor(props) {
    super(props);
    this.onLogin = this.onLogin.bind(this);
    this.logout = this.logout.bind(this);
    this.reset = this.reset.bind(this);
  }

  static triggerGTMEvents(eventName) {
    Analytics.GTM.pushEvent(eventName);
  }

  onLogin() {
    this.props.LoginStore.setloginModal(true);
    ProjectComponent.triggerGTMEvents(GTMEvent.LOGIN_CLICKED);
  }

  get getClassName() {
    return this.props.CommonStore.isBrandPage
      ? "nw-mobileaction-brand-span"
      : "nw-mobileaction-header-span";
  }
  get hideForBrand() {
    return (
      (this.props.CommonStore.isBrandPage &&
        this.props.class === "nw-nnnow-header" &&
        "nwc-hide") ||
      ""
    );
  }
  get isAccount() {
    return this.props.LoginStore.isUserLoggedIn ? "" : "nwc-hide";
  }

  logout() {
    this.props.LoginStore.logoutAction();
    this.props.MybagStore.clearCart();
    ProjectComponent.triggerGTMEvents(GTMEvent.LOGOUT);
    if (window.pageType === "orderconfirmation") {
      window.location = "/";
    }
  }
  reset() {
    this.props.reset();
  }

  render() {
    return (
      <li>
        <ul className={`nw-mobileaction-list ${this.hideForBrand}`}>
          <li className="nw-mobileaction-links">
            <Anchor.component href="/circle" to="/circle" target="_self">
              <Button className="nw-mobileaction-button" onClick={this.reset}>
                <i className="icomoon-envelop nw-mobileaction-icon" />
                <span className={`nw-mobileaction-text ${this.getClassName}`}>
                  {" "}
                  THE CIRCLE{" "}
                </span>
              </Button>
            </Anchor.component>
          </li>
          <li className="nw-mobileaction-links">
            <Anchor.component
              href="/corporate-gifting"
              to="/corporate-gifting"
              target="_self"
            >
              <Button className="nw-mobileaction-button" onClick={this.reset}>
                <i className="icomoon-gift nw-mobileaction-icon" />
                <span className={`nw-mobileaction-text ${this.getClassName}`}>
                  {" "}
                  {TOPBAR.CORPORATE_GIFTING_TEXT}{" "}
                </span>
              </Button>
            </Anchor.component>
          </li>
          <li className="nw-mobileaction-links">
            <Anchor.component
              href={TOPBAR.PRODUCT_VERIFICATION_URL}
              to={TOPBAR.PRODUCT_VERIFICATION_URL}
              target="_self"
            >
              <Button className="nw-mobileaction-button" onClick={this.reset}>
                <i className="icomoon-check nw-otp-check wc-product-verify" />
                <span className={`nw-mobileaction-text ${this.getClassName}`}>
                  {" "}
                  {TOPBAR.PRODUCT_VERIFICATION_TEXT}{" "}
                </span>
              </Button>
            </Anchor.component>
          </li>
          <li
            className={`nw-mobileaction-links nw-mobileaction-account ${this.isAccount}`}
          >
            <a
              href="/account"
              onClick={() =>
                ProjectComponent.triggerGTMEvents(GTMEvent.MYACCOUNT_CLICK)
              }
            >
              <Button className="nw-mobileaction-button">
                <i className="icomoon-person1 nw-mobileaction-icon" />
                <span className={`nw-mobileaction-text ${this.getClassName}`}>
                  {" "}
                  MY ACCOUNT{" "}
                </span>
              </Button>
            </a>
          </li>
          <li className={`nw-mobileaction-links ${this.isAccount}`}>
            <Anchor.component
              href={`${ROUTE_PATHS.MYORDERS}`}
              to={`${ROUTE_PATHS.MYORDERS}`}
              target="_self"
              onClick={() =>
                ProjectComponent.triggerGTMEvents(GTMEvent.MYORDER_CLICK)
              }
            >
              <Button className="nw-mobileaction-button" onClick={this.reset}>
                <i className="icomoon-delivery-web nw-mobileaction-icon" />
                <span className={`nw-mobileaction-text ${this.getClassName}`}>
                  {" "}
                  MY ORDERS{" "}
                </span>
              </Button>
            </Anchor.component>
          </li>
          <li className={`nw-mobileaction-links ${this.isAccount}`}>
            <Anchor.component
              href="/favorites"
              to="/favorites"
              onClick={() =>
                ProjectComponent.triggerGTMEvents(GTMEvent.MYFAVOURITE_CLICK)
              }
            >
              <Button className="nw-mobileaction-button" onClick={this.reset}>
                <i className="icomoon-heart-o nw-mobileaction-icon" />
                <span className={`nw-mobileaction-text ${this.getClassName}`}>
                  {" "}
                  MY FAVOURITES{" "}
                </span>
              </Button>
            </Anchor.component>
          </li>
          <li className="nw-mobileaction-links">
            {this.props.LoginStore.isUserLoggedIn ? (
              <Button className="nw-mobileaction-button" onClick={this.logout}>
                <i className="icomoon-sign-out nw-mobileaction-icon" />
                <span className={`nw-mobileaction-text ${this.getClassName}`}>
                  {" "}
                  SIGN OUT{" "}
                </span>
              </Button>
            ) : (
              <Button
                className="nw-mobileaction-button"
                onClick={this.onLogin}
                onKeyPress={this.onLogin}
              >
                <i className="icomoon-person1 nw-mobileaction-icon" />
                <span className={`nw-mobileaction-text ${this.getClassName}`}>
                  {" "}
                  LOGIN{" "}
                </span>
              </Button>
            )}
          </li>
          <li className="nw-mobileaction-links">
            <Anchor.component
              href="/store-locator"
              to="/store-locator"
              onClick={() =>
                ProjectComponent.triggerGTMEvents(GTMEvent.STORE_LOCATOR_CLICK)
              }
            >
              <Button className="nw-mobileaction-button" onClick={this.reset}>
                <i className="icomoon-marker3 nw-mobileaction-icon" />
                <span className={`nw-mobileaction-text ${this.getClassName}`}>
                  {" "}
                  STORE LOCATOR{" "}
                </span>
              </Button>
            </Anchor.component>
          </li>
          <li className="nw-mobileaction-links">
            <Anchor.component
              href="/contactus"
              to="/contactus"
              onClick={() =>
                ProjectComponent.triggerGTMEvents(GTMEvent.CONTACTUS_CLICK)
              }
            >
              <Button className="nw-mobileaction-button" onClick={this.reset}>
                <i className="icomoon-phone nw-mobileaction-icon" />
                <span className={`nw-mobileaction-text ${this.getClassName}`}>
                  {" "}
                  CONTACT US{" "}
                </span>
              </Button>
            </Anchor.component>
          </li>
        </ul>
      </li>
    );
  }
}

Header.MobileHeader.MobileActionButton.component = getFinalComponent(
  ProjectComponent
);